var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _path70, _path71, _path72, _path73, _path74, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSectionPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1111,
    height: 392,
    viewBox: "0 0 1111 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.10352e-05L185 6.10352e-05C284.433 6.10352e-05 366.573 74.0427 379.291 170H395V41.0001L776.728 41.0001C811.583 41.0001 845.78 50.495 875.646 68.4651C884.534 73.8129 893.841 78.4312 903.476 82.2745L934.059 94.4743C964.739 106.713 997.469 113 1030.5 113L1030.52 113.037C1075.19 114.367 1111 151.002 1111 196C1111 240.998 1075.19 277.633 1030.52 278.963L1030.5 279C997.478 279 964.766 285.379 934.163 297.785L901.526 311.016C892.522 314.667 883.807 318.994 875.456 323.962C845.704 341.659 811.728 351 777.11 351H395V222H379.291C366.573 317.957 284.433 392 185 392H0V6.10352e-05Z",
    fill: "#2D2F3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433 65.0001H508V78.0001H433L433 137L470 137V150L433 150H420L420 137V78.0001V65.0001H433Z",
    fill: "#343744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M526 65.0001H601H614V78.0001V105H601L601 78.0001H526V65.0001Z",
    fill: "#343744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632 65.0001L707 65.0001L720 65.0001L720 78.0001L720 105L707 105L707 78.0001L632 78.0001V65.0001Z",
    fill: "#343744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M720 327L645 327L632 327L632 314L632 287L645 287L645 314L720 314L720 327Z",
    fill: "#343744"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M614 327L539 327L526 327L526 314L526 287L539 287L539 314L614 314L614 327Z",
    fill: "#343744"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433 327H508L508 314H433L433 255L470 255V242L433 242L420 242V255V314V327H433Z",
    fill: "#343744"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 231,
    width: 70,
    height: 243,
    rx: 35,
    transform: "rotate(-90 544 231)",
    fill: "#343744"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 130,
    height: 392,
    fill: "#343744"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 0.0000610352,
    width: 8,
    height: 392,
    fill: "#2D2F3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848 299L848 92",
    stroke: "#343744",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M856 296L856 96",
    stroke: "#343744",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M864 296L864 100",
    stroke: "#343744",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M872 293L872 103",
    stroke: "#343744",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M880 290L880 106",
    stroke: "#343744",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M888 288L888 108",
    stroke: "#343744",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M896 287L896 109",
    stroke: "#343744",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M904 286L904 110",
    stroke: "#343744",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M912 285L912 111",
    stroke: "#343744",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M920 284L920 112",
    stroke: "#343744",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M928 283L928 113",
    stroke: "#343744",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M936 282L936 114",
    stroke: "#343744",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M944 281L944 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M952 281L952 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M960 281L960 115",
    stroke: "#343744",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M840 301L840 90",
    stroke: "#343744",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M832 305L832 86",
    stroke: "#343744",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M824 310L824 81",
    stroke: "#343744",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M816 315L816 76",
    stroke: "#343744",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M808 320L808 71",
    stroke: "#343744",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M138 273H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138 279H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M138 285H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138 291H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138 297H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138 303H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138 309H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138 315H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M138 321H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138 327H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138 333H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138 339H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138 345H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138 351H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138 357H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138 363H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138 369H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138 375H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M138 381H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M138 387H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M138 6.00006H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M138 12.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M138 18.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M138 24.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M138 30.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M138 36.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M138 42.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138 48.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138 54.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138 60.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138 66.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138 72.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138 78.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138 84.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138 90.0001H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M138 96H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M138 102H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M138 108H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138 114H176",
    stroke: "#343744",
    strokeWidth: 2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M779 41.0001L821.045 65.6069C864.563 91.076 914.077 104.5 964.5 104.5V104.5L896.138 69.3506C859.903 50.7192 819.745 41.0001 779 41.0001V41.0001Z",
    fill: "#343744"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M779 350.5L821.045 325.893C864.563 300.424 914.077 287 964.5 287V287L896.138 322.149C859.903 340.781 819.745 350.5 779 350.5V350.5Z",
    fill: "#343744"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 391.998C184.333 391.999 184.666 392 185 392C284.778 392 367.143 317.443 379.421 221H355.196C343.09 304.145 271.502 368 185 368C184.666 368 184.333 367.999 184 367.997V391.998ZM184 344.997C184.333 344.999 184.666 345 185 345C258.771 345 320.021 291.388 331.912 221H307.5C295.918 278.056 245.474 321 185 321C184.666 321 184.333 320.999 184 320.996L184 344.997ZM184 71.004V47.0033C184.333 47.0012 184.666 47.0001 185 47.0001C258.071 47.0001 318.857 99.5992 331.56 169H307.076C294.734 112.943 244.765 71.0001 185 71.0001C184.666 71.0001 184.333 71.0014 184 71.004ZM184 295.995C184.333 295.998 184.666 296 185 296C231.596 296 270.748 264.131 281.85 221H256.792C246.454 250.692 218.215 272 185 272C184.666 272 184.333 271.998 184 271.994V295.995ZM184 120.007V96.005C184.333 96.0017 184.666 96.0001 185 96.0001C230.873 96.0001 269.531 126.888 281.312 169H256.064C245.175 140.356 217.465 120 185 120C184.666 120 184.333 120.002 184 120.007ZM184 24.0029V0.0025583C184.333 0.000894113 184.666 6.10352e-05 185 6.10352e-05C284.087 6.10352e-05 366.001 73.5288 379.156 169H354.893C341.938 86.8338 270.807 24.0001 185 24.0001C184.666 24.0001 184.333 24.001 184 24.0029Z",
    fill: "#343744"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 999,
    cy: 182,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 999,
    cy: 206,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 761,
    cy: 196,
    r: 7,
    fill: "#FD0202",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 981,
    cy: 225,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 959,
    cy: 236,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 243,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 897,
    cy: 250,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 864,
    cy: 257,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 828,
    cy: 267,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 276,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 760,
    cy: 276,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 720,
    cy: 267,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 264,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 260,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 583,
    cy: 257,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 250,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 236,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 218,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 204,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 201,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 341,
    cy: 199,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 192,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 190,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.4
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 226,
    cy: 169,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.6
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 162,
    r: 7,
    fill: "#FD028B",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 967,
    cy: 206,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 929,
    cy: 199,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 894,
    cy: 182,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.4
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 801,
    cy: 144,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 767,
    cy: 140,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 727,
    cy: 130,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 687,
    cy: 130,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 653,
    cy: 133,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 619,
    cy: 137,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 579,
    cy: 140,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 533,
    cy: 147,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 485,
    cy: 161,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 437,
    cy: 178,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 183,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 367,
    cy: 185,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 189,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 185,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 182,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 192,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 211,
    r: 7,
    fill: "#1302FD",
    fillOpacity: 0.1
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 189,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 182,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 168,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.4
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 824,
    cy: 130,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.4
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 794,
    cy: 130,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 768,
    cy: 137,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 734,
    cy: 140,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 140,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 673,
    cy: 133,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 130,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 597,
    cy: 123,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 565,
    cy: 123,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 133,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 526,
    cy: 158,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 172,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 182,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 433,
    cy: 192,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 395,
    cy: 196,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 197,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 326,
    cy: 201,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 282,
    cy: 201,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 204,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.4
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 202,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.8
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 203,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.6
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 218,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 246,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 280,
    r: 7,
    fill: "#0AF807",
    fillOpacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M846 138L838 150",
    stroke: "#EFFFAD",
    strokeWidth: 2
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M867.5 138.5L852 155.5",
    stroke: "#EFFFAD",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M196.5 163L191 197",
    stroke: "#EFFFAD",
    strokeWidth: 2
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M175 167.5L179.5 195",
    stroke: "#EFFFAD",
    strokeWidth: 2
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M883 147.5L868.5 159",
    stroke: "#EFFFAD",
    strokeWidth: 2
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 864,
    cy: 162,
    r: 7,
    fill: "#1302FD"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 155,
    r: 7,
    fill: "#1302FD"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 850,
    cy: 158,
    r: 7,
    fill: "#1302FD"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 887,
    cy: 144,
    r: 7,
    fill: "#0AF807"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 849,
    cy: 133,
    r: 7,
    fill: "#0AF807"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 868,
    cy: 137,
    r: 7,
    fill: "#0AF807"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 158,
    r: 7,
    fill: "#FD028B"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 163,
    r: 7,
    fill: "#FD028B"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 201,
    r: 7,
    fill: "#0AF807"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 200,
    r: 7,
    fill: "#0AF807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSectionPeople);
export default __webpack_public_path__ + "static/media/Map_section_people.9229e52fa47d46cdd06ebbdf6cae70f1.svg";
export { ForwardRef as ReactComponent };